// Schritt-Definition fuer das Labor, im Zuschnitt des Match-Workflows
// (MatchWorkflow.tsx/match-design-rules.ts: STEPS/nextStepId/prevStepId/
// stepIndex/parseStepId), aber auf die Tobis-Domaene gemuenzt statt Team/
// Powers. Eigene, seiten-lokale Kopie statt eines gemeinsamen Primitives: der
// Match-Stepper ist selbst nicht als Primitive dokumentiert (kein
// ADR-0014-Touchpoint, kein Styleguide-Specimen) - eine zweite Kopie wuerde
// daran nichts aendern, siehe Session-Diskussion. Wird dieses Muster ein
// drittes Mal gebraucht, ist DAS der Punkt, es als echtes Primitive
// herauszuziehen (Regel der drei Wiederholungen).

export type LabStepId = "pitch" | "result";

export const LAB_STEPS: ReadonlyArray<{
  n: string;
  id: LabStepId;
  labelId: string;
  defaultLabel: string;
}> = [
  { n: "01", id: "pitch", labelId: "tobis.lab.step.pitch", defaultLabel: "Pitch" },
  { n: "02", id: "result", labelId: "tobis.lab.step.result", defaultLabel: "Result" },
];

export function stepIndex(id: LabStepId): number {
  return LAB_STEPS.findIndex((s) => s.id === id);
}

export function nextStepId(id: LabStepId): LabStepId | null {
  return LAB_STEPS[stepIndex(id) + 1]?.id ?? null;
}

export function prevStepId(id: LabStepId): LabStepId | null {
  return LAB_STEPS[stepIndex(id) - 1]?.id ?? null;
}

// Faellt auf den ersten Schritt zurueck, wenn der Query-Param fehlt oder
// verfaelscht ist - dieselbe Regel wie parseStepId in match-design-rules.ts.
export function parseStepId(value: string | null): LabStepId {
  return LAB_STEPS.some((s) => s.id === value) ? (value as LabStepId) : "pitch";
}
